import { validateEmail, validateRequired } from "./utils/validator.js";
import { http } from "../scripts/api/http.js";
import { showSpinner, hideSpinner } from "../app/components/spinner.js";
import { showSuccess, showError } from "../app/components/toast.js";
import { isAuthenticated, setAuth } from "./utils/auth.js";
import { initSession } from "./utils/session.js";
import { handleError } from "./utils/errorHandler.js";
console.log("✅ login.js loaded");

if (isAuthenticated()) {
	window.location.replace("/app/pages/dashboard.html");
}
window.addEventListener("error", (e) => {
	console.error("🔥 Global JS error caught:", e.message);
});
const loginForm = document.getElementById("loginForm");
const loginBtn = document.getElementById("loginBtn");

loginForm.addEventListener("submit", async (e) => {
	e.preventDefault();
	console.log("📨 Login submitted");
	const email = loginForm.email.value.trim();
	const password = loginForm.password.value.trim();

	if (!validateRequired(email) || !validateEmail(email)) {
		showError("Please enter a valid email");
		return;
	}

	if (!validateRequired(password)) {
		showError("Password is required");
		return;
	}

	loginBtn.disabled = true;
	showSpinner();

	try {
		const res = await http.post(`/auth/login`, { email, password });

		if (res?.success && res.token && res.user) {
			setAuth(res);
			await initSession();
			console.log("✅ Session saved:", res.token);
			showSuccess("Login successful!");

			setTimeout(() => {
				window.location.assign("/app/pages/dashboard.html");

				// Optional
			}, 1000);
		} else {
			handleError(err, "Login failed");
		}
	} catch (err) {
		handleError(err, "Login failed");
	} finally {
		hideSpinner();
		loginBtn.disabled = false;
	}
});
